import { render } from "./VerifyNewUser.vue?vue&type=template&id=62abd15e&scoped=true"
import script from "./VerifyNewUser.vue?vue&type=script&lang=js"
export * from "./VerifyNewUser.vue?vue&type=script&lang=js"

import "./VerifyNewUser.vue?vue&type=style&index=0&id=62abd15e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62abd15e"]])

export default __exports__